import { render, staticRenderFns } from "./AddLinkedAccount.vue?vue&type=template&id=9df989f8&scoped=true"
import script from "./AddLinkedAccount.vue?vue&type=script&lang=js"
export * from "./AddLinkedAccount.vue?vue&type=script&lang=js"
import style0 from "./AddLinkedAccount.vue?vue&type=style&index=0&id=9df989f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df989f8",
  null
  
)

export default component.exports